<template>
  <div class="app-gallery" :class="[loading || imgLoading ? 'sm-loading': '']">
    <AppGalleryLoader v-if="loading"/>
    <template v-else>
      <div class="app-gallery__head">
        <div class="app-gallery__title" v-html="this.title"></div>
        <div class="app-gallery__description" v-html="this.description"></div>
      </div>
      <div class="app-gallery__main">
        <div class="app-gallery__main-prev"
             :class="[activeIndex === 0 ? 'is-disabled' : '']"
             @click="imgPrev" v-show="photos.length">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 4.51471L2.51472 13L11 21.4853" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <div class="app-gallery__main-img sm-item-primary">
          <img :src="src" :alt="alt" ref="mainImage" v-if="this.src">
        </div>
        <div class="app-gallery__main-next"
             :class="[activeIndex === photos.length - 1 ? 'is-disabled' : '']"
             @click="imgNext" v-show="photos.length">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 4.51471L23.4853 13L15 21.4853" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
        <div class="app-gallery__items" v-if="photos.length">
          <div class="app-gallery__item"
               :class="[idx === activeIndex ? 'is-active' : '']" v-for="(photo, idx) in photos"
               :key="idx" @click="onImgChoice(photo.src, photo.description, idx)">
            <img :src="photo.preview" :alt="photo.description">
          </div>
        </div>
      <div class="app-gallery__backward" @click="$emit('galleryQuit')">{{ backwardText }}</div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import _get from 'lodash.get';
import AppGalleryLoader from '@/components/app-gallery-loader/app-gallery-loader.vue';

export default {
  name: 'AppGallery',
  components: {
    AppGalleryLoader,
  },
  props: {
    activeId: [Number, String],
    lang: String,
  },
  data() {
    return {
      src: null,
      alt: '',
      title: '',
      description: '',
      photos: [],
      loading: false,
      imgLoading: false,
      activeIndex: 0,
      backwardText: this.lang === 'ru' ? 'Вернуться обратно' : 'Go back',
    };
  },
  methods: {
    onReturn() {

    },
    imgPrev() {
      this.activeIndex--;
      const src = this.photos[this.activeIndex]?.src;
      const description = this.photos[this.activeIndex]?.description;
      const idx = this.activeIndex;
      this.onImgChoice(src, description, idx);
    },
    imgNext() {
      this.activeIndex++;
      const src = this.photos[this.activeIndex]?.src;
      const description = this.photos[this.activeIndex]?.description;
      const idx = this.activeIndex;
      this.onImgChoice(src, description, idx);
    },
    onImgChoice(src, description, idx) {
      this.imgLoading = true;
      this.src = src;
      this.alt = description;
      this.activeIndex = idx;
      this.$refs.mainImage.onload = () => {
        this.imgLoading = false;
      }
    },
    async getItems() {
      this.loading = true;
      const config = {
        params: {
          lang: this.lang,
          id: this.activeId,
        },
      };
      const res = await this.$api.get('api/gallery/detail', config);
      if (res) {
        this.photos = _get(res, 'data.data.records.event.photos', null);
        this.picture = _get(res, 'data.data.records.event.picture', null);
        const nav = _get(res, 'data.data.records.nav', null);
        const event = _get(res, 'data.data.records.event', null);
        if (nav.length) {
          let title = '';
          nav.forEach(item => {
            title = title + ' ' + item.name;
          });
          this.title = title;
        }
        if (event) {
          this.description = event.name;
        }
        if (this.photos && this.photos.length) {
          this.src = this.photos[0].src;
          this.alt = this.photos[0].description;
        } else if (this.picture) {
          this.src = this.picture.src;
          this.alt = this.picture.description;
        }
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss">
@import "app-gallery";
</style>
